import React from "react";
import HeroHomepageV2Image1 from "../../../assets/images/rebranded_herohomepage_image1_v2.png";
import HeroHomepageV2Image1Es from "../../../assets/rebranding/homeEs/desktop.png";
import HeroHomepageV2Image2 from "../../../assets/images/rebranded_herohomepage_image2_v2.png";
import HeroHomepageV2Image2Es from "../../../assets/rebranding/homeEs/mobile-es.png";
import { getCurrentTranslations } from "../../../utilities/helper";
import "./RebrandingPopup.css";
import Button from "../../reusableComponents/Button/Button";

function RebrandingPopup({ handleRebrandingPopupStatus }) {
    return (
        <div className="fixed bg-white/80 backdrop-blur-[15px] shadow-[0_1px_2px_0_rgba(0,0,0,0.08)] inset-0 z-[9999999] w-full h-full flex flex-col justify-center items-start lg:items-center animate-fade-in p-4 overflow-y-auto">
            <div
                className="relative px-6 pt-4 h-[280px] w-[944px] overflow-hidden rounded-tl-[32px] rounded-tr-[32px] hidden lg:block"
                style={{ background: "linear-gradient(180deg, #FF8000 0%,  #FFEA00 100%)" }}
            >
                <img
                    src={
                        window.currentLanguage === "es"
                            ? HeroHomepageV2Image1Es
                            : HeroHomepageV2Image1
                    }
                    className="z-10 rounded-2xl absolute top-3 right-2 w-[720px]"
                />
                <img
                    src={
                        window.currentLanguage === "es"
                            ? HeroHomepageV2Image2Es
                            : HeroHomepageV2Image2
                    }
                    className="z-50 rounded-2xl absolute top-11 left-2 w-[272px]"
                />
            </div>

            <div
                className="p-10 w-full lg:w-[944px] rounded-tl-[32px] rounded-tr-[32px] lg:rounded-tl-[0px] lg:rounded-tr-[0px] rounded-bl-[32px] rounded-br-[32px]"
                style={{ background: "linear-gradient(180deg,  #83F 0%, #0080FF 100%)" }}
            >
                <div className="flex flex-col">
                    <div className="flex flex-col lg:flex-row justify-between items-center">
                        <div className="font-kapraRegular text-[40px] lg:text-[64px] tracking-[0.64px] leading-[80%] text-white uppercase mb-10 lg:mb-0">
                            {getCurrentTranslations("homepage", "welcomeToThe")} <br />{" "}
                            <span className="rebrandingTitle">
                                {getCurrentTranslations("homepage", "reimagined")}
                            </span>{" "}
                            <br /> My Royal Genie
                        </div>

                        <div
                            className="font-darwinProRegular font-[400] leading-normal text-base text-white w-full lg:w-[472px]"
                            dangerouslySetInnerHTML={{
                                __html: getCurrentTranslations("homepage", "welcomeTextPopup"),
                            }}
                        ></div>
                    </div>

                    <Button
                        type={10}
                        text={getCurrentTranslations("homepage", "welcomeBtnPopup")}
                        className={`w-fit mt-10 mx-auto`}
                        onClick={() => {
                            handleRebrandingPopupStatus();
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

export default RebrandingPopup;
